<template>
<div>
    <workspace-header :isTpg="isTpg"></workspace-header>

    <div class="workspace-content" :class="{isTpg:isTpg}">
        <div class="row">
            <div class="col-md-9">Basic Troubleshooting Instructions (FAQ)</div>

            <div class="col-md-3 faq-bubble-link" :class="{isTpg:isTpg}">
                <a href="/#/support/faq">View</a>
            </div>

        </div>
      <!--   <div class="support-row border-top">
            <div class="col-xs-6">Player Setup Guide</div>
            <div class="col-xs-3"></div>
            <div class="col-xs-2 workspace-bubble-link">
                <a target="_NEW"
                    :href="playerSetupGuideLocation">
                    View
            </a>
            </div>
            <div class="col-xs-1"> </div>
        </div> -->
        <div class="border-top" style="margin-top:10px;padding-top:10px;">
            <div class="col-lg-6">
                <div>
                    <b>Contact Us</b>
                </div>
                <div class="phoneNumberRow">
                    Phone: <span v-html="brandedPhone"></span>
                </div>
                <div >
                    Email: <span v-html="brandedEmail"></span>
                </div>
            </div>
            <div class="col-lg-6">
                <div>
                    <b>Send us a message</b>
                </div>
                <div v-show="messageSent" class="messageReceived">
                    We have received your message and a representative will get back to you shortly.
                </div>
                <form method="post" enctype="multipart/form-data" v-on:submit.prevent="validateBeforeSubmit" v-show="!messageSent">
                    <div :class="{'inputError': v$.contactMessage.$error}">
                    <textarea class="contact-message"
                                name="message"
                                placeholder="Message"
                                v-model="contactMessage"></textarea>
                    </div>
                    <div class="row">
                        <input type="submit" class="contact-submit" />
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';

const Querystring = require('querystring');

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      contactMessage: null,
      error: null,
      messageSent: false,
      playerSetupGuideLocation: '',
    };
  },
  props: ['user-info', 'is-tpg'],
  validations() {
    return {
      contactMessage: { required: helpers.withMessage('Message is required', required) },
    };
  },
  mounted() {
    this.getSetupGuide();
  },
  methods:
    {
      getSetupGuide() {
        const self = this;
        this.$http.get('/documents').then((response) => {
          const allDocs = response.body;
          if (!allDocs) return;
          for (let i = 0; i < allDocs.length; i++) {
            if (allDocs[i].document_name == 'Gray V Setup Guide') {
              self.playerSetupGuideLocation = allDocs[i].document_url;
            }
          }
        });
      },
      sendContact() {
        this.error = null;

        let recipient = 'help@grayv.com';
        let name = 'GRAYV';
        if (this.isTpg) {
          recipient = 'support@theplaylistgeneration.com';
          name = 'TPG';
        }

        const params = Querystring.stringify({
          recipient,
          name: `${name} Help`,
          message: this.contactMessage,
          subject: `Clientweb Contact Form: ${this.userInfo.email}`,
        });

        const self = this;
        this.$http.post('/contact_grayv', params).then(() => {
          self.messageSent = true;
          self.$wkToast('Message sent');
        },
        (response) => {
          self.error = response.data.message;
        });
      },
      validateBeforeSubmit() {
        this.v$.$validate();
        if (!this.v$.$error) {
          this.sendContact();
        } else {
          this.formHasBeenSubmitted = false;
          const errors = this.v$.$errors;
          let errorList = '<b>Errors</b><ul>';
          for (let i = 0; i < errors.length; i++) {
            errorList += `<li>${errors[i].$message}</li>`;
          }

          errorList += '</ul>';
          this.$wkToast(errorList);
        }
      },
    },
  computed: {
    brandedPhone() {
      if (this.isTpg) {
        return '<a style="color:black;" href="tel:323-848-7909">323-848-7909</a>';
      }
      return '<a style="color:white;" href="tel:877-882-5319">877-882-5319</a>';
    },
    brandedEmail() {
      if (this.isTpg) {
        return '<a style="color:black;" href="mailto:support@theplaylistgeneration.com">support@theplaylistgeneration.com</a>';
      }
      return '<a style="color:white;" href="mailto:help@grayv.com">help@grayv.com</a>';
    },
  },
};
</script>

<style scoped>
.faq-bubble-link {
  border:1px solid #efefef;
  text-align: center;
    width:70px;
    border-radius: 5px;
   float:right;
  transition:0.3s;
  height:22px;
  line-height:19px;
  margin-right: 17px;
}
.faq-bubble-link.isTpg {
    background:#808080;
    color:white;
    height:28px;
    line-height:28px;
    width:100px;
}
.messageReceived {
    width:80%;
    margin-top:20px;
    font-style: italic;
}
.support-row {
  height:50px;
  line-height: 50px;
  clear:both;
}
.row .faq-bubble-link{
    margin-bottom:14px;
}
.phoneNumberRow {
    margin-top:16px;
}

.contact-message {
    height:94px;
    width:100%;
    margin-top:18px;
}
.contact-container {
    width:100%;
    padding-top: 20px;
}
.download-settings-link {
  color:rgba(197, 197, 197, 1);
  transition: .3s;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}
@media (max-width:400px) {
  .faq-bubble-link {
    float:left;
    margin-left:8px;
    margin-top:8px;
  }
}
</style>
